// 更改 Vuex 的 store 中的状态的唯一方法是提交 mutation
// this.$store.commit(method, params)

import Vue from 'vue'
import store from '@/store'
import util from './chat/utils'
import config from './chat/config'
import pageUtil from './chat/utils/page'

export default {
    SET_NIM(state, nim) {
        state.nim = nim
    },
    SET_OUT_ACCOUNT_INFO(state, obj) {
        state.accountInfo = {...state.accountInfo, ...obj}
        window.localStorage.setItem('accountInfo', JSON.stringify(state.accountInfo))
    },
    updateAccountInfo(state, obj) {
        state.accountInfo = obj
        window.localStorage.setItem('accountInfo', JSON.stringify(state.accountInfo))
    },
    updateImgList(state, list) {
        state.currentImgList = list
    },
    updateTemSessionId(state, id) {
        state.temSessionId = id
    },
    logInFailedPrompt(state) {
        state.isLoginWrong = true
    },
    updateMyInfo(state, myInfo) {
        state.myInfo = util.mergeObject(state.myInfo, myInfo)
    },
    updateUserInfo(state, users) {
        let userInfos = state.userInfos
        users.forEach(user => {
            let account = user.account
            if (account) {
                userInfos[account] = util.mergeObject(userInfos[account], user)
            }
        })
        state.userInfos = util.mergeObject(state.userInfos, userInfos)
    },
    updateFriends(state, friends, cutFriends = []) {
        let accountList = []
        state.friendsList.forEach(el => {
            accountList.push(el.account)
        })
        friends.forEach(el => {
            if (!accountList.includes(el.account) && el.valid === true) {
                state.friendsList.push(el)
            }
        })
    },
    updateSearchlist(state, obj) {
        const type = obj.type
        switch (type) {
            case 'user':
                if (obj.list.length !== 0 || state.searchedUsers.length !== 0) {
                    state.searchedUsers = obj.list
                } else {
                    state.searchedUsers = []
                }
                break
            case 'team':
                if (obj.list.length !== 0 || state.searchedTeams.length !== 0) {
                    state.searchedTeams = obj.list
                } else {
                    state.searchedTeams = []
                }
                break
            default:
                break
        }
    },
    initLocalMsgs(state, sessions) {
        sessions.forEach(el => {
            let nim = state.nim
            nim.getLocalMsgs({
                sessionId: el.id,
                limit: 100,
                done(error, obj) {
                    if (!error) {
                        // obj.msgs.forEach((el) => {
                        //     el.fromLocal = true;
                        // })
                        state.msgs[obj.sessionId] = obj.msgs.reverse()
                    } else {
                        alert(error)
                    }
                },
            })
        })
    },
    updateSessions(state, sessions) {
        const nim = state.nim
        if (state.sessionList && state.sessionList.length > 0) {
            state.sessionList = nim.mergeSessions(state.sessionList, sessions)
        } else {
            state.sessionList = sessions
        }
        state.sessionList.sort((a, b) => b.updateTime - a.updateTime)
        state.sessionList.forEach(item => {
            state.sessionMap[item.id] = item
        })
    },
    setNimInitComplete(state, status) {
        state.nimInitCompleted = status
    },
    setNimHasContact(state, status) {
        state.nimHasContact = status
    },
    // 初始化，收到离线漫游消息时调用
    updateMsgs(state, msgs) {
        const nim = state.nim
        let tempSessionMap = {}
        msgs.forEach(msg => {
            let sessionId = msg.sessionId
            tempSessionMap[sessionId] = true
            if (!state.msgs[sessionId]) {
                state.msgs[sessionId] = []
            }
            // sdk会做消息去重
            state.msgs[sessionId] = nim.mergeMsgs(state.msgs[sessionId], [msg])
        })
        // store.commit('updateMsgByIdClient', msgs)
        Object.keys(tempSessionMap).forEach(sessionId => {
            if (sessionId === state.currSessionId) {
                store.commit('updateCurrSessionMsgs', {
                    type: 'init',
                })
            }
        })
    },
    // 更新追加消息，追加一条消息
    putMsg(state, msg) {
        let sessionId = msg.sessionId
        if (!state.msgs[sessionId]) {
            state.msgs[sessionId] = []
        }
        // store.commit('updateMsgByIdClient', msg)
        let tempMsgs = state.msgs[sessionId]
        let lastMsgIndex = tempMsgs.length - 1
        if (tempMsgs.length === 0 || msg.time >= tempMsgs[lastMsgIndex].time) {
            tempMsgs.push(msg)
        } else {
            for (let i = lastMsgIndex; i >= 0; i--) {
                let currMsg = tempMsgs[i]
                if (msg.time >= currMsg.time) {
                    state.msgs[sessionId].splice(i, 0, msg)
                    break
                }
            }
        }
    },
    // 删除消息列表消息
    deleteMsg(state, msg) {
        let sessionId = msg.sessionId
        let tempMsgs = state.msgs[sessionId]
        if (!tempMsgs || tempMsgs.length === 0) {
            return
        }
        let lastMsgIndex = tempMsgs.length - 1
        for (let i = lastMsgIndex; i >= 0; i--) {
            let currMsg = tempMsgs[i]
            if (msg.idClient === currMsg.idClient) {
                state.msgs[sessionId].splice(i, 1)
                break
            }
        }
    },
    // 替换消息列表消息，如消息撤回
    replaceMsg(state, obj) {
        let {sessionId, idClient} = obj
        let tempMsgs = state.msgs[sessionId]
        if (!tempMsgs || tempMsgs.length === 0) {
            return
        }
        let lastMsgIndex = tempMsgs.length - 1
        for (let i = lastMsgIndex; i >= 0; i--) {
            let currMsg = tempMsgs[i]
            if (idClient === currMsg.idClient) {
                state.msgs[sessionId].splice(i, 1)
                state.msgs[sessionId].push(obj)
                break
            }
        }
    },
    // 用idClient 更新消息，目前用于消息撤回
    // updateMsgByIdClient (state, msgs) {
    //   if (!Array.isArray(msgs)) {
    //     msgs = [msgs]
    //   }
    //   let tempTime = (new Date()).getTime()
    //   msgs.forEach(msg => {
    //     // 有idClient 且 5分钟以内的消息
    //     if (msg.idClient && (tempTime - msg.time < 1000 * 300)) {
    //       state.msgsMap[msg.idClient] = msg
    //     }
    //   })
    // },
    // 更新当前会话id，用于唯一判定是否在current session状态
    updateCurrSessionId(state, obj) {
        let type = obj.type || ''
        if (type === 'destroy') {
            state.currSessionId = null
        } else if (type === 'init') {
            if (obj.sessionId && (obj.sessionId !== state.currSessionId)) {
                state.currSessionId = obj.sessionId
            }
        }
    },
    // 更新当前会话列表的聊天记录，包括历史消息、单聊消息等，不包括聊天室消息
    // replace: 替换idClient的消息
    updateCurrSessionMsgs(state, obj) {
        let type = obj.type || ''
        if (type === 'destroy') { // 清空会话消息
            state.currSessionMsgs = []
            state.currSessionLastMsg = null
            store.commit('chat/updateCurrSessionId', {
                type: 'destroy',
            })
        } else if (type === 'init') { // 初始化会话消息列表
            if (state.currSessionId) {
                let sessionId = state.currSessionId
                let currSessionMsgs = [].concat(state.msgs[sessionId] || [])
                // 做消息截断
                let limit = config.localMsglimit
                let msgLen = currSessionMsgs.length
                if (msgLen - limit > 0) {
                    state.currSessionLastMsg = currSessionMsgs[msgLen - limit]
                    currSessionMsgs = currSessionMsgs.slice(msgLen - limit, msgLen)
                } else if (msgLen > 0) {
                    state.currSessionLastMsg = currSessionMsgs[0]
                } else {
                    state.currSessionLastMsg = null
                }
                state.currSessionMsgs = []
                let lastMsgTime = 0
                let users = currSessionMsgs.map(msg => msg.from)
                if (users.length > 0) {
                    nim.getUsers({
                        accounts: users,
                        done: function searchUsersDone(error, userList) {
                            currSessionMsgs.forEach(msg => {
                                userList.some(el => {
                                    if (el.account === msg.from) {
                                        msg.avatar = el.avatar
                                    }
                                })
                                if ((msg.time - lastMsgTime) > 300000 && msg.type !== 'notification') {
                                    lastMsgTime = msg.time
                                    state.currSessionMsgs.push({
                                        type: 'timeTag',
                                        text: util.formatDate(msg.time, state.locale, false),
                                    })
                                }
                                if (msg.type !== 'notification') {
                                    state.currSessionMsgs.push(msg)
                                }
                            })
                            store.dispatch('chat/checkTeamMsgReceipt', state.currSessionMsgs)
                        },
                    })
                } else {
                    currSessionMsgs.forEach(msg => {
                        if ((msg.time - lastMsgTime) > 300000 && msg.type !== 'notification') {
                            lastMsgTime = msg.time
                            state.currSessionMsgs.push({
                                type: 'timeTag',
                                text: util.formatDate(msg.time, state.locale, false),
                            })
                        }
                        if (msg.type !== 'notification') {
                            state.currSessionMsgs.push(msg)
                        }
                    })
                    store.dispatch('chat/checkTeamMsgReceipt', state.currSessionMsgs)
                }
            }
        } else if (type === 'put') { // 追加一条消息
            let newMsg = obj.msg
            let lastMsgTime = 0
            let lenCurrMsgs = state.currSessionMsgs.length
            if (lenCurrMsgs > 0) {
                lastMsgTime = state.currSessionMsgs[lenCurrMsgs - 1].time
            }
            if (newMsg) {
                nim.getUser({
                    account: newMsg.from,
                    done: function searchUsersDone(error, user) {
                        newMsg.avatar = user.avatar
                        if ((newMsg.time - lastMsgTime) > 300000) {
                            state.currSessionMsgs.push({
                                type: 'timeTag',
                                text: util.formatDate(newMsg.time, state.locale, false),
                            })
                        }
                        state.currSessionMsgs.push(newMsg)
                        pageUtil.scrollChatListDown()
                        store.dispatch('chat/checkTeamMsgReceipt', [newMsg])
                    },
                })
            }
        } else if (type === 'concat') {
            // 一般用于历史消息拼接
            let currSessionMsgs = []
            let lastMsgTime = 0
            let users = obj.msgs.map(msg => msg.from)
            if (users.length > 0) {
                nim.getUsers({
                    accounts: users,
                    done: function searchUsersDone(error, userList) {
                        let msgList = []
                        obj.msgs.forEach(msg => {
                            if (!state.currSessionMsgs.some(item => item.idClient === msg.idClient)) {
                                msgList.push(msg)
                            }
                        })
                        obj.msgs = msgList
                        obj.msgs.forEach(msg => {
                            // 用于判断上拉加载得到的信息，便于控制滚动条位置
                            msg.fromHistory = true
                            userList.some(el => {
                                if (el.account === msg.from) {
                                    msg.avatar = el.avatar
                                }
                            })
                            if ((msg.time - lastMsgTime) > 300000 && msg.type !== 'notification') {
                                lastMsgTime = msg.time
                                currSessionMsgs.push({
                                    type: 'timeTag',
                                    fromHistory: true,
                                    text: util.formatDate(msg.time, state.locale, false),
                                })
                            }
                            if (msg.type !== 'notification') {
                                currSessionMsgs.push(msg)
                            }
                        })
                        currSessionMsgs.reverse()
                        // 之前新加载的历史信息可以理解为老信息
                        state.currSessionMsgs.forEach(msg => {
                            msg.fromHistory = false
                        })
                        currSessionMsgs.forEach(msg => {
                            state.currSessionMsgs.unshift(msg)
                        })
                        if (obj.msgs[0]) {
                            state.currSessionLastMsg = obj.msgs[0]
                        }
                        store.dispatch('chat/checkTeamMsgReceipt', currSessionMsgs)
                    },
                })
            } else {
                obj.msgs.forEach(msg => {
                    // 用于判断上拉加载得到的信息，便于控制滚动条位置
                    msg.fromHistory = true
                    if ((msg.time - lastMsgTime) > 300000 && msg.type !== 'notification') {
                        lastMsgTime = msg.time
                        currSessionMsgs.push({
                            type: 'timeTag',
                            fromHistory: true,
                            text: util.formatDate(msg.time, state.locale, false),
                        })
                    }
                    if (msg.type !== 'notification') {
                        currSessionMsgs.push(msg)
                    }
                })
                currSessionMsgs.reverse()
                // 之前新加载的历史信息可以理解为老信息
                state.currSessionMsgs.forEach(msg => {
                    msg.fromHistory = false
                })
                currSessionMsgs.forEach(msg => {
                    state.currSessionMsgs.unshift(msg)
                })
                if (obj.msgs[0]) {
                    state.currSessionLastMsg = obj.msgs[0]
                }
                store.dispatch('chat/checkTeamMsgReceipt', currSessionMsgs)
            }
        } else if (type === 'replace') {
            let msgLen = state.currSessionMsgs.length
            let lastMsgIndex = msgLen - 1
            if (msgLen > 0) {
                for (let i = lastMsgIndex; i >= 0; i--) {
                    if (state.currSessionMsgs[i].idClient === obj.msg.idClient) {
                        state.currSessionMsgs.splice(i, 1)
                        state.currSessionMsgs.push(obj.msg)
                        break
                    }
                }
            }
            store.dispatch('chat/checkTeamMsgReceipt', state.currSessionMsgs)
        }
    },
    updateSysMsgs(state, sysMsgs) {
        const nim = state.nim
        if (!Array.isArray(sysMsgs)) {
            sysMsgs = [sysMsgs]
        }
        sysMsgs = sysMsgs.map(msg => {
            msg.showTime = util.formatDate(msg.time, state.locale, false)
            return msg
        })
        // state.sysMsgs = nim.mergeSysMsgs(state.sysMsgs, sysMsgs)
        state.sysMsgs = [].concat(nim.mergeSysMsgs(state.sysMsgs, sysMsgs))
        Vue.set(state, sysMsgs, state.sysMsgs)
    },
    // 更新消息的状态，如管理员批准或拒绝入群后，会收到新消息，更新入群申请的状态
    updateSysMsgState(state, sysMsg) {
        let exitMsg = state.sysMsgs.find(msg => msg.idServer === sysMsg.idServer)
        if (exitMsg) {
            exitMsg.state = sysMsg.state
        }
    },
    updateSysMsgUnread(state, obj) {
        state.sysMsgUnread = {...obj}
    },
    updateCustomSysMsgs(state, sysMsgs) {
        const nim = state.nim
        if (!Array.isArray(sysMsgs)) {
            sysMsgs = [sysMsgs]
        }
        sysMsgs = sysMsgs.map(msg => {
            msg.showTime = util.formatDate(msg.time, state.locale, false)
            return msg
        })
        // state.customSysMsgs = nim.mergeSysMsgs(state.customSysMsgs, sysMsgs)
        state.customSysMsgs = state.customSysMsgs.concat(sysMsgs)
        Vue.set(state, 'customSysMsgs', state.customSysMsgs)
        store.commit('updateCustomSysMsgUnread', {
            type: 'add',
            unread: sysMsgs.length,
        })
    },
    updateCustomSysMsgUnread(state, obj) {
        let {type, unread} = obj
        switch (type) {
            case 'reset':
                state.customSysMsgUnread = unread || 0
                break
            case 'add':
                state.customSysMsgUnread += unread
                break
            default:
                break
        }
    },
    resetSysMsgs(state, obj) {
        let type = obj.type
        switch (type) {
            case 0:
                state.sysMsgs = []
                break
            case 1:
                state.customSysMsgs = []
                store.commit('updateCustomSysMsgUnread', {
                    type: 'reset',
                })
                break
            default:
                break
        }
    },
    deleteSysMsgs(state, obj) {
        let type = obj.type
        let idServer = obj.idServer
        let arr = type === 0 ? state.sysMsgs : state.customSysMsgs
        arr = arr.filter(msg => msg.idServer !== idServer)
        Vue.set(state, 'sysMsgs', arr)
    },
    setNoMoreHistoryMsgs(state) {
        state.noMoreHistoryMsgs = true
    },
    resetNoMoreHistoryMsgs(state) {
        state.noMoreHistoryMsgs = false
    },
    updateTeamList(state, teams) {
        const nim = state.nim
        store.state.teamlist = nim.mergeTeams(store.state.teamlist, teams)
        store.state.teamlist = nim.cutTeams(store.state.teamlist, teams.invalid)
    },
    updateSentReceipedMap(state, obj) {
        if (!obj || obj.length < 1) {
            return
        }
        let teamId = obj[0].teamId
        if (!state.sentReceipedMap[teamId]) {
            state.sentReceipedMap[teamId] = []
        }
        state.sentReceipedMap[teamId].push(...obj.map(msg => msg.idServer))
    },
    updateReceiptQueryList(state, obj) {
        if (state.currReceiptQueryTeamId !== obj.teamId) {
            state.receiptQueryList = []
            state.teamMsgReads = []
            state.currReceiptQueryTeamId = obj.teamId
        }
        let needQuery = obj.msgs
            .filter(msg => msg.needMsgReceipt && msg.from === state.myInfo.account && !state.receiptQueryList.find(item => item.idServer === msg.idServer))
            .map(msg => ({
                teamId: obj.teamId,
                idServer: msg.idServer,
            }))
        if (needQuery.length > 0) {
            state.receiptQueryList.push(...needQuery)
        }
        if (needQuery.length > 0) {
            needQuery.forEach(el => {
                store.dispatch('chat/getTeamMsgReads', el)
            })
            // store.dispatch('chat/getTeamMsgReads', needQuery)
        }
    },
    updateTeamMsgReads(state, obj) {
        state.teamMsgReads.push(...obj.teamMsgReceipts)
    },
    updateSingleTeamMsgReads(state, obj) {
        if ((store.getters.isServiceLogin && obj.account.includes('customer'))
        || !store.getters.isServiceLogin) {
            let index
            state.currSessionMsgs.some((msg, i) => {
                if (msg.idClient === obj.idClient) {
                    index = i
                }
            })
            if (index) {
                let _msg = state.currSessionMsgs[index]
                _msg.isRead = true
                state.currSessionMsgs.splice(index, 1, _msg)
            }
        }
    },
    initMsgReceiptDetail(state, obj) {
        if (obj.readAccounts.length > 0) {
            let ifRead = obj.readAccounts.some(account => account.includes('customer'))
            if (ifRead === true) {
                let index
                state.currSessionMsgs.some((msg, i) => {
                    if (msg.idClient === obj.idClient['102']) {
                        index = i
                    }
                })
                if (index) {
                    let _msg = state.currSessionMsgs[index]
                    _msg.isRead = true
                    state.currSessionMsgs.splice(index, 1, _msg)
                }
            }
        }
        state.teamMsgReadsDetail.push(obj)
        // state.teamMsgReadsDetail.readAccounts = obj.readAccounts
        // state.teamMsgReadsDetail.unreadAccounts =  obj.unreadAccounts
    },
    updateFullScreenImage(state, obj) {
        obj = obj || {}
        if (obj.src && obj.type === 'show') {
            state.fullscreenImgSrc = obj.src
            state.isFullscreenImgShow = true
        } else if (obj.type === 'hide') {
            state.fullscreenImgSrc = ' '
            state.isFullscreenImgShow = false
        }
    },
}
